import { createStore } from 'vuex';
import { appConfigModule } from "./modules/appconfig.module";
import { loginModule } from "./modules/login.module";
import { licenseModule } from "./modules/license.module";
import { userFeaturesModule } from "./modules/user-features.module";
import { backgroundTasksModule } from "./modules/background-tasks.module";
const store = createStore({
    state: {
        version: "1.0.0"
    },
    modules: {
        loginModule,
        appConfigModule,
        licenseModule,
        userFeaturesModule,
        backgroundTasksModule
    },
});
export default store;
